<script setup>
import { computed } from 'vue';

const props = defineProps({
  users: {
    type: Array,
    default: () => []
  }
});

const typingText = computed(() => {
  if (props.users.length === 0) return '';
  if (props.users.length === 1) {
    const user = props.users[0];
    return `${user.firstName || 'Someone'} is typing`;
  }
  if (props.users.length === 2) {
    return `${props.users[0].firstName} and ${props.users[1].firstName} are typing`;
  }
  return 'Several people are typing';
});
</script>

<template>
  <v-row v-if="users.length > 0" class="typing-indicator-row" no-gutters>
    <v-col cols="auto" class="typing-indicator-container">
      <div class="typing-bubble">
        <span class="typing-text text-caption">
          {{ typingText }}
        </span>
        <div class="typing-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<style scoped>
.typing-indicator-row {
  margin-bottom: 12px;
}

.typing-indicator-container {
  display: flex;
  align-items: center;
}

.typing-bubble {
  background-color: rgb(var(--v-theme-light));
  padding: 8px 12px;
  border-radius: 12px;
  border-bottom-left-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.typing-text {
  opacity: 0.7;
  font-style: italic;
}

.typing-dots {
  display: flex;
  gap: 3px;
  align-items: center;
}

.dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: rgba(var(--v-theme-on-surface), 0.5);
  animation: typing 1.4s infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%, 60%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  30% {
    opacity: 1;
    transform: scale(1.2);
  }
}
</style>
